import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // Cookie Banner
    agreedToPrivacy: false,

    // Barrierefreiheit
    highContrast: false,

    // Pagination Company
    currentPageCompany: 1,

    // Pagination Exhibition
    currentPageExhibition: 1,

    // Pagination Event
    currentPageEvent: 1,

    // Pagination Blog
    currentPageBlog: 1,

    // Pagination Jobs
    currentPageJobs: 1,

    // Pagination Search
    currentPageSearch: 1,

    // Jobs Filter
    jobFilter: {
      // Menu
      showCity: false,
      showOffer_typeMenu: false,
      showDegreeMenu: false,
      showEduDegreeMenu: false,
      showActivityMenu: false,
      showSoftskillsMenu: false,
      showTemporaryMenu: false,
      showOthersMenu: false,
      showWorking_planMenu: false,
      showOthersMenu: false,
      // JobSearch
      term: null,
      city: null,
      company: null,
      // JobFilter
      cityFilter: null,
      degree: null,
      education_degree: null,
      activity: null,
      softskill: null,
      takeover: null,
      temporary: null,
      minijob: null,
      handicap: false,
      offer_type: [],
      working_plan: [],
      travel: null,
      payscale_bound: null
    },

    // Event Filter
    filter: {
      group: null,
      type: null,
      year: null,
      format: null,
      company: null
    },

    // Exhibition Form
    form: {
      // step1
      name: "",
      address: "",
      zip: "",
      city: "",
      website: "",
      company_email: "",

      // step2
      firstname: "",
      lastname: "",
      phone: "",
      email: "",
      newsletter: false,
      // union: false,
      companies: "",
    //   sector: "",

      // step3
      sqm_outside: null,
      sqm_inside: null,
      power: null,
      heavy_current: null,
      water: null,
      tables: null,
      chairs: null,

      // step4
      comment: "",
      // privacy: false
    }
  },
  mutations: {
    // Initialise Store
    initialiseStore(state) {
      if (localStorage.getItem('agreedToPrivacy')) {
        state.agreedToPrivacy = true;
      }
    },

    // Cookie Banner
    agreePrivacyPolicy(state) {
      localStorage.setItem('agreedToPrivacy', true);
      state.agreedToPrivacy = true;
    },

    //Pagination Company
    setCurrentPageCompany(state, payload) {
      state.currentPageCompany = payload.currentPageCompany
    },

    //Pagination Exhibition
    setCurrentPageExhibition(state, payload) {
      state.currentPageExhibition = payload.currentPageExhibition
    },

    //Pagination Event
    setCurrentPageEvent(state, payload) {
      state.currentPageEvent = payload.currentPageEvent
    },

    //Pagination Blog
    setCurrentPageBlog(state, payload) {
      state.currentPageBlog = payload.currentPageBlog
    },

    //Pagination Search
    setCurrentPageSearch(state, payload) {
      state.currentPageSearch = payload.currentPageSearch
    },

    // Events
    // company Fitler
    setEventCompany(state, payload) {
      state.filter.company = payload.eventCompany
    },

    //Jobs
    //Pagination
    setCurrentPageJobs(state, payload) {
      state.currentPageJobs = payload.currentPageJobs
    },

    // Show Jobs Menus
    setShowCity(state, payload) {
      state.jobFilter.showCity = payload.showCity
    },
    setShowOffer_typeMenu(state, payload) {
      state.jobFilter.showOffer_typeMenu = payload.showOffer_typeMenu
    },
    setShowDegreeMenu(state, payload) {
      state.jobFilter.showDegreeMenu = payload.showDegreeMenu
    },
    setShowEduDegreeMenu(state, payload) {
      state.jobFilter.showEduDegreeMenu = payload.showEduDegreeMenu
    },
    setShowActivityMenu(state, payload) {
      state.jobFilter.showActivityMenu = payload.showActivityMenu
    },
    setShowSoftskillsMenu(state, payload) {
      state.jobFilter.showSoftskillsMenu = payload.showSoftskillsMenu
    },
    setShowTemporaryMenu(state, payload) {
      state.jobFilter.showTemporaryMenu = payload.showTemporaryMenu
    },
    setShowWorking_planMenu(state, payload) {
      state.jobFilter.showWorking_planMenu = payload.showWorking_planMenu
    },
    setShowOthersMenu(state, payload) {
      state.jobFilter.showOthersMenu = payload.showOthersMenu
    },
    // Set Job Search
    setTerm(state, payload) {
      state.jobFilter.term = payload.term
    },
    setCity(state, payload) {
      state.jobFilter.city = payload.city
    },
    // Set Job Filter

    setCityFilter(state, payload) {
      state.jobFilter.cityFilter = payload.cityFilter
    },
    setJobCompany(state, payload) {
      state.jobFilter.company = payload.jobCompany
    },
    pushOffer_type(state, payload) {
      state.jobFilter.offer_type.push(payload.offer_type)
    },
    spliceOffer_type(state, payload) {
      const index = state.jobFilter.offer_type.indexOf(payload.offer_type);
      if (index > -1) {
        state.jobFilter.offer_type.splice(index, 1);
      }
    },
    clearOffer_type(state) {
      state.jobFilter.offer_type = []
    },
    pushWorking_plan(state, payload) {
      state.jobFilter.working_plan.push(payload.working_plan)
    },
    spliceWorking_plan(state, payload) {
      const index = state.jobFilter.working_plan.indexOf(payload.working_plan);
      if (index > -1) {
        state.jobFilter.working_plan.splice(index, 1);
      }
    },
    clearWorking_plan(state) {
      state.jobFilter.working_plan = []
    },
    setDegree(state, payload) {
      state.jobFilter.degree = payload.degree
    },
    setEducation_degree(state, payload) {
      state.jobFilter.education_degree = payload.education_degree
    },
    setActivity(state, payload) {
      state.jobFilter.activity = payload.activity
    },
    setSoftskill(state, payload) {
      state.jobFilter.softskill = payload.softskill
    },
    setTakeover(state, payload) {
      state.jobFilter.takeover = payload.takeover
    },
    setTemporary(state, payload) {
      state.jobFilter.temporary = payload.temporary
    },
    setMinijob(state, payload) {
      state.jobFilter.minijob = payload.minijob
    },
    setHandicap(state, payload) {
      state.jobFilter.handicap = payload.handicap
    },
    setTravel(state, payload) {
      state.jobFilter.travel = payload.travel
    },
    setPayscale_bound(state, payload) {
      state.jobFilter.payscale_bound = payload.payscale_bound
    },

    // Null Filters
    nullFilters(state) {
      state.jobFilter.city = null,
        // state.jobFilter.term = null,
        state.jobFilter.cityFilter = null,
        state.jobFilter.degree = null,
        state.jobFilter.education_degree = null,
        state.jobFilter.activity = null,
        state.jobFilter.softskill = null,
        state.jobFilter.takeover = null,
        state.jobFilter.temporary = null,
        state.jobFilter.minijob = null,
        state.jobFilter.handicap = false,
        state.jobFilter.offer_type = [],
        state.jobFilter.working_plan = [],
        state.jobFilter.travel = null,
        state.jobFilter.payscale_bound = null
    },
    // close Menus
    closeMenus(state) {
      state.jobFilter.showOffer_typeMenu = false,
        state.jobFilter.showDegreeMenu = false,
        state.jobFilter.showEduDegreeMenu = false,
        state.jobFilter.showActivityMenu = false,
        state.jobFilter.showSoftskillsMenu = false,
        state.jobFilter.showTemporaryMenu = false,
        state.jobFilter.showOthersMenu = false,
        state.jobFilter.showWorking_planMenu = false,
        state.jobFilter.showOthersMenu = false
    },

    // Barrierefreiheit
    setHighContrast(state, payload) {
      state.highContrast = payload.highContrast
    },

    // Exhibition-Form
    // reset Form
    resetExhibitionForm(state) {
      state.form.name = '';
      state.form.address = '';
      state.form.zip = '';
      state.form.city = '';
      state.form.website = '';
      state.form.lastname = '';
      state.form.firstname = '';
      state.form.phone = '';
      state.form.email = '';
      state.form.company_email = "";
      state.form.newsletter = false;
    //   state.form.union = false;
      state.form.companies = "";
    //   state.form.sector = "";
      state.form.sqm_outside = null;
      state.form.sqm_inside = null;
      state.form.power = null;
      state.form.heavy_current = null;
      state.form.water = null;
      state.form.tables = null;
      state.form.chairs = null;
      state.form.comment = "";
    },
    // step1
    setName(state, payload) {
      state.form.name = payload.name
    },
    setAddress(state, payload) {
      state.form.address = payload.address
    },
    setZip(state, payload) {
      state.form.zip = payload.zip
    },
    setCity(state, payload) {
      state.form.city = payload.city
    },
    setWebsite(state, payload) {
      state.form.website = payload.website
    },
    setCompany_email(state, payload) {
      state.form.company_email = payload.company_email
    },
    // step2
    setLastname(state, payload) {
      state.form.lastname = payload.lastname
    },
    setFirstname(state, payload) {
      state.form.firstname = payload.firstname
    },
    setPhone(state, payload) {
      state.form.phone = payload.phone
    },
    setEmail(state, payload) {
      state.form.email = payload.email
    },
    setNewsletter(state, payload) {
      state.form.newsletter = payload.newsletter
    },
    // setUnion(state, payload) {
    //   state.form.union = payload.union
    // },
    setCompanies(state, payload) {
      state.form.companies = payload.companies
    },
    // setSector(state, payload) {
    //   state.form.sector = payload.sector
    // },
    // step3
    setSqm_outside(state, payload) {
      state.form.sqm_outside = payload.sqm_outside
    },
    setSqm_inside(state, payload) {
      state.form.sqm_inside = payload.sqm_inside
    },
    setPower(state, payload) {
      state.form.power = payload.power
    },
    setHeavy_current(state, payload) {
      state.form.heavy_current = payload.heavy_current
    },
    setWater(state, payload) {
      state.form.water = payload.water
    },
    setTables(state, payload) {
      state.form.tables = payload.tables
    },
    setChairs(state, payload) {
      state.form.chairs = payload.chairs
    },
    // step4
    setComment(state, payload) {
      state.form.comment = payload.comment
    },
    setPrivacy(state, payload) {
      state.form.privacy = payload.privacy
    },
  },
  actions: {
  },
  modules: {
  }
})
